import React from "react";
import { Box, Divider, Grid, IconButton } from "@mui/material";
import { Typography } from "@mui/material";
import { Container } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getDataByGasType } from "../../Functions/APIservice/gasAPI";
import BasicMovies from "./BasicMovies";
import { BasicUniversalViewerService } from "../../Modules/Viewer/BasicUniversalViewerService";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import { useNavigate } from "react-router-dom";
import { MstaFontFamily } from "../../Functions/Style/MstaFont";

type BasicContentsType = {
  DicomData: getDataByGasType[];
  SubParts: string[];
  selectSubPart: string;
  title: string;
  PartInfo: string;
  KeyWords: string;
  MoviePart: string;
  isQuatro: boolean;
};

export function BasicContents(props: BasicContentsType) {
  const {
    DicomData,
    SubParts,
    selectSubPart,
    title,
    PartInfo,
    KeyWords,
    MoviePart,
    isQuatro,
  } = props;

  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  // 表示させるDicomのデータセット
  const [DicomDatas, setDicomDatas] = React.useState<getDataByGasType[]>(
    DicomData.filter((value) => SubParts.includes(value.subPart))
  );

  const handleOpenLink = (url: string) => {
    const toUrl = url;
    navigate(toUrl);
  };

  const handleBackClick = () => {
    handleOpenLink("/basic");
  };

  return (
    <div>
      {width >= 1300 && (
        <Box
          sx={{
            position: "absolute",
            left: "calc((100vw - 1200px) / 2 - 36px)",
            top: "96px",
          }}
        >
          <IconButton
            sx={{
              color: "#9CA4AD",
              border: "1px solid #9CA4AD",
            }}
            onClick={handleBackClick}
          >
            <ArrowBackIcon />
          </IconButton>
        </Box>
      )}

      <Container
        maxWidth="lg"
        sx={{ mt: 1, mb: 1, pt: 3, pb: 4, position: "relative" }}
      >
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          {width < 1300 && width >= 600 && (
            <Box
              sx={{
                mr: 2,
              }}
            >
              <IconButton
                sx={{
                  color: "#9CA4AD",
                  border: "1px solid #9CA4AD",
                }}
                onClick={handleBackClick}
              >
                <ArrowBackIcon />
              </IconButton>
            </Box>
          )}

          <Box sx={{ flexGrow: 1 }}>
            <Typography
              gutterBottom
              align="left"
              variant="h4"
              fontFamily={MstaFontFamily}
            >
              {title}
            </Typography>

            <Divider
              sx={{
                borderBottomWidth: 1.5,
                borderColor: "black",
                mt: 1,
                mb: 4,
              }}
            />

            <Grid container spacing={3} sx={{ mt: 1 }}>
              <Grid item xs={12} md={6}>
                <BasicUniversalViewerService
                  dicomDatas={DicomDatas}
                  title={title}
                  subParts={SubParts}
                  selectSubPart={selectSubPart}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <BasicMovies part={MoviePart} />
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Container>
    </div>
  );
}
